var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"regions"},[_c('h1',[_vm._v("Coach Tour Regions")]),_c('Regions')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }